import React from 'react';

import s from '../index.module.scss';

export const ActivityTableHeader = ({ isQueue }: { isQueue?: boolean }) => {
  return (
    <div className={isQueue ? s.queueTableTitleWrapper : s.historyTableTitleWrapper}>
      <span className={s.noneTableTitle}>Nonce/Name</span>
      <span>Initiator address</span>
      <span>Date</span>
      <span>Fee</span>
      <span>Status</span>
      {isQueue && <span />}
    </div>
  );
};
